import { Box, Checkbox, TableCell, TableRow, Tooltip } from '@mui/material';
import React from 'react';
import RestoreIcon from '@mui/icons-material/Restore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { AttachFile } from '@mui/icons-material';
import LessMoreComp from '../../../shared_elements/components/CustomLessMoreComp';
import moment from 'moment';
import UploadingIcon from '../../../shared_elements/components/UploadingIcon';
import { trackActivity } from '../../../utils/mixpanel';
import { PermissionWrapper } from '../../../wrappers';
import AuditPopover from '../../../shared_elements/components/popover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { dateMonthYearDateFormat } from '../../../constants';

const ReferenceDocumentList = ({ uploadedFileData, slug, uploadFileProgressData, viewFileStatus, item, viewRevisonHistory, onView, onEdit, viewFile, onDelete, bulk, toggleBulkOps }) => {

  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Reference Documents Listing`, page_type: page_type, })
  }
  return (
    <TableRow>
      <TableCell className="table-actions-list">
        <Box className="table-icon-container">
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reference_document", operationType: ['D'] }}>
            <Checkbox size='small' sx={{ cursor: 'pointer' }}
              onChange={(e) => toggleBulkOps(e.target.checked, "single", item)}
              checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false} />
          </PermissionWrapper>
          <AuditPopover item={item}>
            <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
          </AuditPopover>
          <Tooltip title="Revision History"><RestoreIcon className='revision-history' fontSize='small' onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} color='primary' sx={{ cursor: 'pointer' }} /></Tooltip>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reference_document", operationType: ['R'] }}>
            <Tooltip title="View"><VisibilityIcon fontSize='small' color='primary' sx={{ cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('ViewIcon') }} /></Tooltip>
          </PermissionWrapper>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reference_document", operationType: ['U'] }}>
            <Tooltip title="Edit"><EditIcon fontSize='small' color='primary' sx={{ cursor: 'pointer' }} onClick={() => { onEdit(); handleItemClicked('EditIcon') }} /></Tooltip>
          </PermissionWrapper>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reference_document", operationType: ['D'] }}>
            <Tooltip title="Delete"><DeleteIcon fontSize='small' color='error' sx={{ cursor: 'pointer' }} onClick={() => { onDelete(); handleItemClicked('DeleteIcon') }} /></Tooltip>
          </PermissionWrapper>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reference_document", operationType: ['R'] }}>
            {
              item?.attachments?.length > 0 &&
              <Tooltip title="Attached File(s)">
                <Box className="attachment-container">
                  <AttachFile fontSize="small" color="primary" sx={{ cursor: "pointer" }} onClick={() => { viewFile(); handleItemClicked('AttachmentsIcon') }} />
                  <Box className="attachment-count"> ({item.attachments.length}) </Box>
                </Box>
              </Tooltip>
            }
          </PermissionWrapper>
          {(slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} />}
        </Box>
      </TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.name?.length > 50 ? "200px" : '' }}><LessMoreComp name={item?.name} lessMr='name' /></div></TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.validity_start_date ? moment(item?.validity_start_date).format(dateMonthYearDateFormat) : "--"}</TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.validity_end_date ? moment(item?.validity_end_date).format(dateMonthYearDateFormat) : "--"}</TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.description?.length > 50 ? "300px" : '' }}><LessMoreComp name={item?.description} lessMr='Description' /></div></TableCell>
    </TableRow>
  )
}

export default ReferenceDocumentList;